export default {
  getContents(context) {
    return window.axios.get("/setup/portal/contents").then(({ data }) => {
      const contents = Array.isArray(data) ? data : data.results || [];
      context.commit("setContents", contents);
      return contents;
    });
  }
};
